import React from 'react';
import { Button } from '../common';
import { useNavigate } from 'react-router-dom';

import { ArrowRight } from 'lucide-react';

export const CTASection: React.FC = () => {
  const navigate = useNavigate();

  const handleNavigation = (path: string) => {
    navigate(path);
    window.scrollTo(0, 0);
  };

  return (
    <section className="px-4 md:px-16 py-16 md:py-24 lg:py-28 bg-[#FBF5ED]">
      <div className="container mx-auto">
        <div
          className="max-w-4xl mx-auto text-center"
        >
          <h2 className="mb-6 text-4xl md:text-5xl lg:text-6xl font-bold font-gabarito text-Color-Neutral-Darkest leading-tight">
            Want to learn more?
          </h2>
          <p className="mb-8 text-lg md:text-xl text-Color-Neutral-Dark font-cairo max-w-2xl mx-auto">
            Discover our mission, vision, and MindClave's commitment to making AI useful for everyone.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button 
              variant="primary" 
              size="lg"
              onClick={() => handleNavigation('/about')}
            >
              About MindClave
            </Button>
            <button 
              onClick={() => handleNavigation('/contact')}
              className="flex items-center gap-2 text-Color-Neutral-Dark hover:text-[#C97B5A] transition-colors font-cairo font-medium group"
            >
              Get in Touch
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};